export const Colors = {
	black: '#000000',
	dark: '#000000',
	black_a90: '#000000E5',
	black_a80: '#000000CC',
	black_a70: '#000000B3',
	black_a60: '#00000099',
	black_a50: '#00000080',
	black_a40: '#00000066',
	black_a30: '#0000004D',
	black_a25: '#00000040',
	black_a20: '#00000033',
	black_a10: '#0000001A',
	black_a8: '#00000014',
	black_a5: '#0000000D',
	black_a2: '#00000005',
	'000000DE': '#000000DE',
	'11141299': '#11141299',
	'101010': '#101010',
	'191919': '#191919',
	'202020': '#202020',
	'161616': '#161616',
	'151515': '#151515',
	'363636': '#363636',
	'232323': '#232323',
	'121212': '#121212',
	'2B2B2B': '#2B2B2B',
	'2A2A2A': '#2A2A2A',
	'070605': '#070605',
	'1A1A1A': '#1A1A1A',
	'1E1E1E': '#1E1E1E',
	'1F1F1F': '#1F1F1F',
	'141414': '#141414',
	'120E0D': '#120E0D',
	'9B9B9B': '#9B9B9B',
	'F3F3F7': '#F3F3F7',
	'FCFCFD': '#FCFCFD',
	'FCFCFD_a80': '#F3F3F7CC',
	'F3F3F7_a20': '#F3F3F733',
	'E9E9E9': '#E9E9E9',
	'757575': '#757575',
	'E9E9E9_a10': '#E9E9E91A',
	redDarken: '#341212',
	redLight: '#FF060633',
	red: '#FF0606',
	'FB5353': '#FB5353',
	'FB5353_a10': '#FB53531A',
	'FB5353_a20': '#FB535333',
	redDark: '#BB2121',
	tomato: '#F13939',
	tomato_a20: '#F1393933',
	redPinkBorder: 'rgba(241, 57, 57, 0.20)',
	error: '#FF563F',
	'FA5634': '#FA5634',
	'EA521F': '#EA521F',
	orange: '#FF6000',
	'F19239': '#F19239',
	'F19239_a10': '#F192391A',
	yellow: '#FFE23F',
	yellow2: '#FFF521',
	yellow_a15: 'rgba(255, 184, 0, 0.15)',
	'F2AF00': '#F2AF00',
	green: '#278141',
	green_a20: '#27814133',
	'60C0B5_a10': '#60C0B51A',
	'10C79B': '#10C79B',
	'10C79B_a10': '#10C79B1A',
	'3DD598': '#3DD598',
	'3DD598_a10': '#3DD5981A',
	'ED4024': '#ED4024',
	'FF6767': '#FF6767',
	'FF6767_a10': '#FF67671A',
	'F4933F': '#F4933F',
	lightBlue: '#007CFF',
	lightBluePressed: '#0288d1',
	link: '#0D74CE',
	blue: '#321AF1',
	'321AF1': '#321AF1',
	'0065E9': '#0065E9',
	purple: '#B656F8',
	pink: '#EE4C9A',
	metalic: '#4F5069',
	orangePressed: '#E05920',
	blackPressed: '#28282B',
	bluePressed: '#0B1E4A',
	redPressed: '#FF463F',
	'171717': '#171717',
	'272727': '#272727',
	'252525': '#252525',
	'222222': '#222222',
	'3A3A3A': '#3A3A3A',
	'313131': '#313131',
	'6D7275': '#6D7275',
	'939393': '#939393',
	'969696': '#969696',
	'888888': '#888888',
	'808080': '#808080',
	'737373': '#737373',
	'C5C5C5': '#C5C5C5',
	'555555': '#555555',
	'484848': '#484848',
	'343434': '#343434',
	'333333': '#333333',
	'ECECEC': '#ECECEC',
	'F4F4F4': '#F4F4F4',
	'D9D9D9': '#D9D9D9',
	'4A4A4A': '#4A4A4A',
	'FAFAFA': '#FAFAFA',
	ECECEC1A: '#ECECEC1A',
	ECECEC2B: '#ECECEC2B',
	F8F7F6CC: '#F8F7F6CC',
	'7D7D7D80': '#7D7D7D80',
	white_a2: '#ffffff05',
	white_a5: '#FFFFFF0D',
	white_a8: '#FFFFFF14',
	white_a10: '#FFFFFF1A',
	white_a15: '#FFFFFF26',
	white_a20: '#FFFFFF33',
	'D7D7D74D': '#D7D7D74D',
	white_a30: '#FFFFFF4D',
	white_a40: '#FFFFFF66',
	white_a50: '#ffffff80',
	white_a60: '#FFFFFF99',
	white_a70: '#FFFFFFB2',
	white_a80: '#FFFFFFCC',
	white_a87: '#FFFFFFDE',
	white_a90: '#FFFFFFE6',
	F1F1F1: '#F1F1F1',
	grayLight: '#D5D6DA',
	gray: '#838AA0',
	grayDark: '#4A4E55',
	gray_a60: 'rgba(17, 20, 18, 0.60)',
	gray2_a70: 'rgba(24, 24, 24, 0.70)',
	gray_a70: 'rgba(68, 68, 68, 0.70)',
	gray_191919_a50: 'rgba(19, 19, 19, 0.50)',
	gray_61686B: '#61686B',
	grayTransparent: '#A6AAB2',
	fontColor: '#FFFFFF',
	white: '#FFFFFF',
	blueTransparent: '#24396A29',
	blueTransparentLight: '#24396A0A',
	blackTransparent: 'rgba(0, 0, 0, 0.23)',
	tertiary: '#969696',
	transparent: 'transparent',
	inherit: 'inherit',
};

export const inputBackgroundColor = Colors.white_a10;
export const inputForegroundColor = Colors.white;
export const inputPlaceholderColor = Colors.white_a40;
export const inputBorderColor = Colors.transparent;

export const inputErrorBorderColor = Colors.error;
export const inputDisabledForegroundColor = Colors.grayDark;
export const inputDisabledBackgroundColor = Colors.white_a5;
export const inputDisabledPlaceholderColor = Colors.grayDark;
export const inputFocusBorderColor = Colors.white_a70;
export const inputDisabledBorderColor = Colors.transparent;

export const HostGradients = {
	[Colors.orange]: `linear-gradient(180deg, ${Colors.orange} -1%, #993A00 105%)`,
	[Colors.blue]: `linear-gradient(180deg, ${Colors.blue} 0%, #1D0F8B 100%)`,
	[Colors.yellow]: `linear-gradient(180deg, ${Colors.yellow} 0%, #998826 100%)`,
	[Colors.green]: `linear-gradient(180deg, ${Colors.green} 0%, #081B0E 100%)`,
	[Colors.purple]: `linear-gradient(180deg, ${Colors.purple} 0%, #6B3392 100%)`,
	[Colors.pink]: `linear-gradient(180deg, ${Colors.pink} 0%, #882B58 100%)`,
	[Colors.tomato]: `linear-gradient(180deg, ${Colors.tomato} 0%, #8B2121 100%)`,
	[Colors.metalic]: `linear-gradient(180deg, ${Colors.metalic} 0%, #9B9DCF 100%)`,
};

export const defaultCommunityColor = Colors.metalic;
